export let employeeStatus = {
    'candidate': 'Neue Bewerbung',
    'interviewee': 'Telefontermin versendet',
    'telephone-interview': 'Telefontermin',
    'data-requested': 'Stammdaten angefordert',
    'data-provided': 'Stammdaten vom Bewerber bearbeitet',
    'data-verified': 'Stammdaten komplett',
    'training-session': 'Schulungstermin',
    'training-verified': 'Schulung abgeschlossen',
    'offered': 'Vertragsangebot',
    'onboarding': 'onboarding',
    'rebuddy': 'Rebuddy',
    'data-re-requested': 'Stammdatencheck angefordert',
    'data-re-provided': 'Stammdaten bestätigt',
    're-offered': 'Vertragsangebot',
    'active': 'Aktiver Mitarbeiter',
    // 'sabbatical': 'Freigestellt',
    'inactive': 'Inaktiv',
    'pool': 'Pool',

}


export let maritalStatus = {
    'single': 'Ledig',
    'divorced': 'Geschieden',
    'married': 'Verheiratet',
    'widowed': 'Verwitwet',
    'other': 'Sonstiger Status'
}

export let motorVehicleLicense = {
    '0': 'Kein Führerschein',
    'car': 'Klasse B'
}

// export let statusOptions = [
//     {name: 'Neue Bewerbung', value: 'candidate'},
//     {name: 'Telefontermin gebucht', value: 'interviewee'},
//     {name: 'Im Bewerbungsprozess', value: 'onboarding'},
//     {name: 'Aktiv', value: 'active'},
//     {name: 'Inaktiv', value: 'inactive'},
//     {name: 'Freigestellt', value: 'sabbatical'},
// ]

export let statusOptions = {
    'candidate': 'Neue Bewerbung',
    'interviewee': 'Telefontermin gebucht',
    'onboarding': 'Im Bewerbungsprozess',
    'active': 'Aktiv',
    'sabbatical': 'Freigestellt',
    'inactive': 'Inaktiv'
}
export const genderOptions = {
    'male': 'Männlich',
    'female': 'Weiblich',
    'other': 'Divers'
}



export const asSelectItems = (obj: {[key: string]: string}) => Object.entries(obj ).map(([key, value]: [string, string]) => ({value: key, name: value}))